"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "email-details-wrapper"
  }, [_c("div", {
    staticClass: "email-details-card"
  }, [_c("div", {
    staticClass: "email-header"
  }, [_c("div", {
    staticClass: "email-header__top"
  }, [_c("div", {
    staticClass: "email-header__subject-row"
  }, [_c("h1", {
    staticClass: "email-subject"
  }, [_vm._v(" " + _vm._s(_vm.formData.subject || "(No Subject)") + " ")]), _c("div", {
    staticClass: "email-header__actions"
  }, [_c("el-button", {
    attrs: {
      type: _vm.formData.isStarred ? "warning" : "default",
      icon: _vm.formData.isStarred ? "el-icon-star-on" : "el-icon-star-off",
      circle: "",
      title: _vm.formData.isStarred ? "Unstar" : "Star"
    },
    on: {
      click: _vm.toggleStar
    }
  }), _c("el-button", {
    attrs: {
      type: "primary",
      icon: "el-icon-plus"
    },
    on: {
      click: _vm.addToLead
    }
  }, [_vm._v(" Add to Lead ")])], 1)]), _c("div", {
    staticClass: "email-meta"
  }, [_c("div", {
    staticClass: "email-meta__item"
  }, [_c("span", {
    staticClass: "email-meta__label"
  }, [_vm._v("From")]), _c("span", {
    staticClass: "email-meta__value"
  }, [_vm._v(_vm._s(_vm.formData.from))])]), _c("div", {
    staticClass: "email-meta__item"
  }, [_c("span", {
    staticClass: "email-meta__label"
  }, [_vm._v("Date")]), _c("span", {
    staticClass: "email-meta__value"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.formData.receivedAt, "DD MMM YYYY, hh:mm a")))])])])])]), _c("el-divider", {
    staticClass: "email-divider"
  }), _c("div", {
    staticClass: "email-body-wrapper"
  }, [_c("div", {
    staticClass: "email-body",
    domProps: {
      innerHTML: _vm._s(_vm.formData.body)
    }
  })])], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;